import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ProcessLogout } from "../../Util/Process-Logout";

const SignOut = () => {
  const location = useLocation();

  const { locale } = useParams();

  useEffect(() => {
    const ssologout = new URLSearchParams(location.search).get("ssologout") || "";
    const domain = new URLSearchParams(location.search).get("cd") || "";
    const nextLogout = new URLSearchParams(location.search).get("nextlg") || "";

    ProcessLogout(ssologout, domain, nextLogout, "");
  }, []);

  return (
    <div>
      {" "}
      <div className="displaymobile">
        <img
          className="legalsimpli-logo height-37 mt-3 mb-3 ps-20"
          src={process.env.PUBLIC_URL + "/static/images/legalsimpli-logov2.svg"}
          alt="PDFsimpli"
          draggable="false"
        />
      </div>
      <section className="section main-content text-center">
        <div className="container intro">
          <div className="row">
            <div className="col-12 headline-group">
              <hgroup>
                <h2>Please wait...</h2>
              </hgroup>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SignOut;
